const fileInfoServiceName = "/FileInfo";

export function fileInfoService (http) {
    return {
        getAllCategoriesAsync: async (pageNumber, pageSize, sortBy, filters) => {
            const newSort = (sortBy || []).map(item => ({
                member: item.id,
                sortDirection: item.desc ? "Descending" : "Ascending"
            }));


            const filter=filters;
            const data = {
                dataAttribute:{
                    page:pageNumber,
                    pageSize,
                    sorts: newSort.lenght==0?[{member:"StartDate",sortDirection:"Ascending"}]:newSort,
                    filter: filter
                }
            }
            return await http.post(fileInfoServiceName + '/GetFilesInfoAsync', data);
        },
        getCategoriesAsync: async () => {
            return await http.get(fileInfoServiceName + '/GetCategories');
        },
        saveFileInfoAsync: async(Id = 0, title, showDate, categoryId, 
            fileAddress, fileId, fileName,fileType, result, priority, operationState) => {
            const data = { Id, title, showDate, categoryId, fileName, priority, operationState, file : {fileAddress, fileId, fileName, fileType, result}};
            return await http.post(fileInfoServiceName + '/SaveFileInfoAsync', data);
        },
        deleteFileInfoAsync: async(id, mediaFileId) => {
            const data = { id, mediaFileId };
            
            return await http.post(fileInfoServiceName + '/DeleteFileInfoAsync', data);
        },
        getSingleFileInfo: mediaFileIds => {
            const data = { mediaFileIds };
            
            return http.post(fileInfoServiceName + '/GetSingleFileInfo', data);
        },
        isDisplayPriorityValidAsync: async (dateFrom, dateTo, displayPriority) => {
            const parameterObject = { dateFrom, dateTo, displayPriority };

            return await http.post(fileInfoServiceName + '/IsDisplayPriorityValidAsync', parameterObject);
        }
    }
}
